/* Collection page.

   Three things: the hero button, the donations carousel and the FAQ
   accordion. All three are the preview's own, word for word. */

// ---- the hero button ----
// It points at the grid's own id, so with no script at all the browser still
// jumps there and nothing is lost. What the script adds is the smooth run and
// the room a theme's sticky header takes: a section cannot know that header's
// height, so it is measured at the moment of the click, and only where the
// header is really stuck to the top of the viewport.
(function () {
  var links = document.querySelectorAll('.nextdev--collection__cta[href^="#"]');
  if (!links.length) return;

  function stuckHeight() {
    var nodes = document.querySelectorAll('header, sticky-header, .section-header, #shopify-section-header');
    var height = 0;
    for (var i = 0; i < nodes.length; i++) {
      var position = getComputedStyle(nodes[i]).position;
      if (position !== 'fixed' && position !== 'sticky') continue;
      var box = nodes[i].getBoundingClientRect();
      // at the top of the viewport, and drawing something
      if (box.top > 1 || box.bottom <= 0) continue;
      if (box.bottom > height) height = box.bottom;
    }
    return height;
  }

  Array.prototype.forEach.call(links, function (link) {
    link.addEventListener('click', function (event) {
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = window.pageYOffset + target.getBoundingClientRect().top - stuckHeight();
      window.scrollTo({ top: top < 0 ? 0 : top, behavior: reduced ? 'auto' : 'smooth' });
    });
  });
})();

// ---- the donations carousel ----
// The band the theme draws with the video reviews carousel section. That
// section leans on Swiper; nothing in this repo loads a library, so the loop
// is written by hand the way ugc-section already does it: the slides are
// cloned once before and once after the real set, and the index is pulled
// back into the middle copy after every move, which is what makes it endless
// in both directions.
(function () {
  var root = document.querySelector('[data-nextdev-donations]');
  if (!root) return;

  var band = root.closest('.nextdev--collection__donations');
  var viewport = root.querySelector('[data-nextdev-donations-viewport]');
  var track = root.querySelector('[data-nextdev-donations-track]');
  var prevBtn = root.querySelector('[data-nextdev-donations-prev]');
  var nextBtn = root.querySelector('[data-nextdev-donations-next]');
  if (!viewport || !track) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var real = Array.prototype.slice.call(track.querySelectorAll('[data-nextdev-donations-slide]'));
  var count = real.length;
  if (!count) return;

  var head = document.createDocumentFragment();
  var tail = document.createDocumentFragment();
  real.forEach(function (slide) {
    head.appendChild(slide.cloneNode(true));
    tail.appendChild(slide.cloneNode(true));
  });
  track.insertBefore(head, track.firstChild);
  track.appendChild(tail);

  var slides = Array.prototype.slice.call(track.querySelectorAll('[data-nextdev-donations-slide]'));
  var index = count;
  var slideWidth = 0;
  var gap = 0;
  var stepWidth = 0;
  var innerWidth = 0;
  var inView = true;

  function number(name, fallback) {
    var value = parseFloat(getComputedStyle(band).getPropertyValue(name));
    return isNaN(value) ? fallback : value;
  }

  // the slide's size is the band's to state, so one place holds both ends
  // of the breakpoint
  function measure() {
    var styles = getComputedStyle(viewport);
    innerWidth = viewport.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
    slideWidth = number('--nextdev-collection-slide-w', 240);
    gap = number('--nextdev-collection-slide-gap', 12);
    stepWidth = slideWidth + gap;
  }

  // centred once there is room for a slide on either side, and against the
  // left edge on a phone, where there is no middle one to speak of
  function offsetFor(i) {
    if (window.innerWidth <= 749) return -(i * stepWidth);
    return innerWidth / 2 - (i * stepWidth + slideWidth / 2);
  }

  function place(offset) {
    band.style.setProperty('--nextdev-collection-slide-x', offset.toFixed(2) + 'px');
  }

  function jump(offset) {
    track.classList.add('nextdev--collection__carousel-track--still');
    place(offset);
    void track.offsetHeight;
    track.classList.remove('nextdev--collection__carousel-track--still');
  }

  function normalise() {
    if (index >= count && index < count * 2) return;
    index = count + (((index % count) + count) % count);
    jump(offsetFor(index));
    markActive();
  }

  // ---- the videos ----
  // Only the slide in the middle plays, and only while the band is on
  // screen. Everything else is paused and its button put back to play.
  function pauseButtonOf(slide) {
    return slide.querySelector('[data-nextdev-donations-pause]');
  }

  function showPaused(slide, paused) {
    var button = pauseButtonOf(slide);
    if (button) button.setAttribute('data-paused', paused ? 'true' : 'false');
  }

  function playActive() {
    var slide = slides[index];
    if (!slide || !inView) return;
    var video = slide.querySelector('video');
    if (!video) return;
    showPaused(slide, false);
    var started = video.play();
    if (started && started.catch) {
      started.catch(function () {
        // a browser that refuses to start it leaves the button offering to
        showPaused(slide, true);
      });
    }
  }

  function pauseTheRest() {
    slides.forEach(function (slide, i) {
      if (i === index) return;
      var video = slide.querySelector('video');
      if (!video) return;
      video.pause();
      showPaused(slide, true);
    });
  }

  function markActive() {
    slides.forEach(function (slide, i) {
      slide.classList.toggle('nextdev--collection__slide--active', i === index);
    });
    pauseTheRest();
    playActive();
  }

  function goTo(i) {
    index = i;
    place(offsetFor(index));
    markActive();
    if (reduced) normalise();
  }

  function step(direction) {
    goTo(index + direction);
  }

  track.addEventListener('transitionend', function (event) {
    if (event.target === track && event.propertyName === 'transform') normalise();
  });

  if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

  // the buttons ride on cloned slides too, so the track listens for both
  track.addEventListener('click', function (event) {
    var slide = event.target.closest('[data-nextdev-donations-slide]');
    if (!slide) return;
    // a drag that happens to end on a button is not a click on it
    if (Math.abs(moved) > 6) return;
    var video = slide.querySelector('video');
    if (!video) return;

    var pause = event.target.closest('[data-nextdev-donations-pause]');
    if (pause) {
      if (pause.getAttribute('data-paused') === 'true') {
        video.play();
        pause.setAttribute('data-paused', 'false');
      } else {
        video.pause();
        pause.setAttribute('data-paused', 'true');
      }
      return;
    }

    var mute = event.target.closest('[data-nextdev-donations-mute]');
    if (mute) {
      var muted = mute.getAttribute('data-muted') === 'true';
      video.muted = !muted;
      mute.setAttribute('data-muted', muted ? 'false' : 'true');
    }
  });

  // one video ending hands the band on to the next slide
  slides.forEach(function (slide) {
    var video = slide.querySelector('video');
    if (!video) return;
    video.muted = true;
    video.addEventListener('ended', function () {
      if (slide.classList.contains('nextdev--collection__slide--active')) step(1);
    });
  });

  // ---- drag with the pointer, on the trackpad and on touch ----
  var pressed = false;
  var dragging = false;
  var startX = 0;
  var startOffset = 0;
  var moved = 0;
  var pointerId = null;

  viewport.addEventListener('pointerdown', function (event) {
    if (event.button !== 0) return;
    pressed = true;
    dragging = false;
    moved = 0;
    pointerId = event.pointerId;
    startX = event.clientX;
    startOffset = offsetFor(index);
  });

  viewport.addEventListener('pointermove', function (event) {
    if (!pressed) return;
    moved = event.clientX - startX;
    if (!dragging) {
      if (Math.abs(moved) < 4) return;
      dragging = true;
      track.classList.add('nextdev--collection__carousel-track--still');
      viewport.classList.add('nextdev--collection__carousel-viewport--dragging');
      viewport.setPointerCapture(pointerId);
    }
    place(startOffset + moved);
  });

  function endDrag() {
    if (!pressed) return;
    pressed = false;
    if (!dragging) {
      pointerId = null;
      return;
    }
    dragging = false;
    track.classList.remove('nextdev--collection__carousel-track--still');
    viewport.classList.remove('nextdev--collection__carousel-viewport--dragging');
    if (pointerId !== null && viewport.hasPointerCapture(pointerId)) {
      viewport.releasePointerCapture(pointerId);
    }
    pointerId = null;

    var slid = -moved / stepWidth;
    var jumped = 0;
    if (Math.abs(slid) > 0.15) {
      jumped = slid > 0 ? Math.max(1, Math.round(slid)) : Math.min(-1, Math.round(slid));
    }
    goTo(index + jumped);
    if (!jumped) normalise();
  }

  viewport.addEventListener('pointerup', endDrag);
  viewport.addEventListener('pointercancel', endDrag);
  viewport.addEventListener('dragstart', function (event) { event.preventDefault(); });

  // ---- nothing plays off screen ----
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      inView = entries[0].isIntersecting;
      if (inView) {
        playActive();
      } else {
        slides.forEach(function (slide) {
          var video = slide.querySelector('video');
          if (!video) return;
          video.pause();
          showPaused(slide, true);
        });
      }
    }, { threshold: 0.5 }).observe(root);
  }

  // ---- start, and follow the width ----
  function layout() {
    measure();
    jump(offsetFor(index));
    markActive();
  }

  layout();
  window.addEventListener('load', layout);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(layout, 150);
  });
})();

/* FAQ.

 One question opens at a time on click. The panel animates on max-height, so
 it is measured on open and released to none once the transition lands, and
 an open panel is released again on resize in case the answer reflows. */

(function () {
'use strict';

var OPEN_CLASS = 'nextdev--faq__answer--open';
var openPanels = [];

function open(head, body, sign) {
  body.classList.add(OPEN_CLASS);
  head.setAttribute('aria-expanded', 'true');
  if (sign) sign.textContent = '−';
  body.style.maxHeight = body.scrollHeight + 'px';
  if (openPanels.indexOf(body) === -1) openPanels.push(body);
  var done = function (e) {
    if (e.propertyName !== 'max-height') return;
    if (body.classList.contains(OPEN_CLASS)) body.style.maxHeight = 'none';
    body.removeEventListener('transitionend', done);
  };
  body.addEventListener('transitionend', done);
}

function close(head, body, sign) {
  body.style.maxHeight = body.scrollHeight + 'px';
  void body.offsetHeight;
  body.classList.remove(OPEN_CLASS);
  head.setAttribute('aria-expanded', 'false');
  if (sign) sign.textContent = '+';
  body.style.maxHeight = '0px';
  var i = openPanels.indexOf(body);
  if (i > -1) openPanels.splice(i, 1);
}

function bind(head) {
  var body = head.nextElementSibling;
  if (!body || head.dataset.nextdevFaqInit) return;
  head.dataset.nextdevFaqInit = '1';
  var sign = head.querySelector('.nextdev--faq__sign');
  body.style.maxHeight = '0px';
  head.addEventListener('click', function () {
    if (body.classList.contains(OPEN_CLASS)) {
      close(head, body, sign);
    } else {
      open(head, body, sign);
    }
  });
}

function init(root) {
  (root || document).querySelectorAll('[data-nextdev-faq]').forEach(bind);
}

var resizeTimer;
window.addEventListener('resize', function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    openPanels.forEach(function (body) {
      body.style.maxHeight = 'none';
    });
  }, 150);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { init(); });
} else {
  init();
}

// the theme editor swaps the section out and back in
document.addEventListener('shopify:section:load', function (e) {
  init(e.target);
});
})();